import { memo } from 'react';
import { components, MultiValueGenericProps } from 'react-select';
import { Tag } from '@chakra-ui/react';

import { ControlledSelectOption } from '../types/ControlledSelectOption';

const MultiValueContainerComponent = <IsMulti extends boolean = false>({
  children,
  ...props
}: MultiValueGenericProps<ControlledSelectOption, IsMulti>) => (
  <components.MultiValueContainer {...props}>
    <Tag.Root colorPalette="brandSecondary" size="lg" variant="surface">
      {children}
    </Tag.Root>
  </components.MultiValueContainer>
);

export const MultiValueContainer = memo(
  MultiValueContainerComponent,
) as typeof MultiValueContainerComponent;
